



































































































































































import { Vue, Component, Mixins } from "vue-property-decorator";

import MyList from "@/mixins/list";
import MyListExtends from "@/mixins/list-extends";

import Detail from "./components/perception-detail.vue";
import Total from "./components/total.vue";

@Component({ components: { Total, Detail } })
export default class extends Mixins(MyList, MyListExtends) {
  dispatchType = "groupPerception/list";

  loading2: boolean = false;

  // 操作搜索栏的展开和折叠
  isFlag = false;


  total: any = {
    all: {},
    today: {}
  };

  editModalVisible = false;

  editId = 0;

  perception: any = {};

  status: any = 0;

  // 发送结果:1-等待发送；2-发送成功；3-发送失败
  statusOption: any[] = [
    { id: -1, name: "组局中", color: "#2db7f5" },
    { id: 1, name: "组局成功", color: "#87d068" },
    { id: 2, name: "组局失败", color: "red" }
  ];

  // 短信类型：1-系统通知；2-订单通知；3-平台充值通知；4-场馆充值通知；
  typeOption: any[] = [
    { id: 1, name: "球友圈", color: "#ffbc00" },
    { id: 2, name: "场馆俱乐部", color: "#2db7f5" },
    { id: 3, name: "城市俱乐部", color: "#2db7f5" }
  ];

  columns: any[] = [
    { title: "编号", dataIndex: "id" },
    // { title: "组局时间", dataIndex: "created_time" },
    { title: "首次响应时间", dataIndex: "first_responed_time" },
    { title: "打球时间", dataIndex: "valid_time_start" },
    { title: "场馆", dataIndex: "stadium_name" },

    { title: "下单时间", dataIndex: "paid_time" },
    { title: "状态", scopedSlots: { customRender: "status" } },
    { title: "类型", scopedSlots: { customRender: "sms_type" } },

    {
      title: "应邀人数",
      // dataIndex: "join_count",
      scopedSlots: { customRender: "join_count" }
    },
    {
      title: "未响应人数",
      // dataIndex: "pending_count",
      scopedSlots: { customRender: "pending_count" }
    },

    {
      title: "去不了人数",
      // dataIndex: "cancel_count",
      scopedSlots: { customRender: "cancel_count" }
    }

    // { title: "操作", scopedSlots: { customRender: "action" } }
  ];

  mounted() {
    this.loadData();
    this.loading2 = true;
    this.fetchTotal(true);
    this.fetchTotal(false);
    this.loading2 = false;
  }

  hideEditModal() {
    this.editModalVisible = false;
  }

  handleDetail(record: any, iType: number) {
    this.editId = record.id;
    this.perception = record;
    this.status = iType;
    this.editModalVisible = true;
  }

  async fetchTotal(isToday: boolean) {
    this.$store
      .dispatch("groupPerception/total", { is_today: isToday ? 1 : 0 })
      .then(data => {
        console.log("groupPerception/total", data);

        if (isToday) {
          this.total.today = data.Data;
        } else {
          this.total.all = data.Data;
        }
      });
  }
}
